import { ApiService } from "@/api";

export const getGroupDetailLeader = (groupId: string) => {
  return ApiService.baseAction(`/group/${groupId}/detail`, {}, 'get');
}